// Funciones puras para el formato de hoja de impresión de etiquetas: no
// tocan Firebase ni UI, solo calculan el valor por defecto y validan que la
// combinación de columnas/filas/tamaño/márgenes quepa en una hoja carta.
// Mismo criterio que bulkEditLogic.js: separadas del componente para poder
// probarlas sin montar nada.

const HOJA_ANCHO_MM = 215.9; // carta, igual que jsPDF({ unit: "mm", format: "letter" })
const HOJA_ALTO_MM = 279.4;

export function defaultSheetFormat() {
  return {
    columnas: 3,
    filas: 10,
    margenSuperior: 10,
    margenInferior: 10,
    margenIzquierdo: 4,
    margenDerecho: 4,
    separacionHorizontal: 3,
    separacionVertical: 0,
    etiquetaAncho: 67,
    etiquetaAlto: 25,
  };
}

const CAMPOS_POSITIVOS = ["columnas", "filas", "etiquetaAncho", "etiquetaAlto"];
const CAMPOS_NO_NEGATIVOS = [
  "margenSuperior",
  "margenInferior",
  "margenIzquierdo",
  "margenDerecho",
  "separacionHorizontal",
  "separacionVertical",
];

// Devuelve { [campo]: mensaje } solo para los campos con error — un objeto
// vacío significa que el formato es válido.
export function validateSheetFormat(values) {
  const errores = {};
  const v = values || {};

  CAMPOS_POSITIVOS.forEach((campo) => {
    const n = Number(v[campo]);
    if (!Number.isFinite(n) || n <= 0) {
      errores[campo] = "Debe ser un número mayor a 0";
    }
  });
  CAMPOS_NO_NEGATIVOS.forEach((campo) => {
    const n = Number(v[campo]);
    if (!Number.isFinite(n) || n < 0) {
      errores[campo] = "Debe ser un número mayor o igual a 0";
    }
  });

  if (Object.keys(errores).length > 0) return errores;

  const anchoTotal =
    v.margenIzquierdo +
    v.margenDerecho +
    v.columnas * v.etiquetaAncho +
    (v.columnas - 1) * v.separacionHorizontal;
  if (anchoTotal > HOJA_ANCHO_MM) {
    errores.columnas = `${v.columnas} columnas de ${v.etiquetaAncho}mm no caben en el ancho de la hoja carta (${HOJA_ANCHO_MM}mm) con estos márgenes y separación — el total da ${anchoTotal.toFixed(1)}mm`;
  }

  const altoTotal =
    v.margenSuperior +
    v.margenInferior +
    v.filas * v.etiquetaAlto +
    (v.filas - 1) * v.separacionVertical;
  if (altoTotal > HOJA_ALTO_MM) {
    errores.filas = `${v.filas} filas de ${v.etiquetaAlto}mm no caben en el alto de la hoja carta (${HOJA_ALTO_MM}mm) con estos márgenes y separación — el total da ${altoTotal.toFixed(1)}mm`;
  }

  return errores;
}
